/*
 * @Description: 
 * @Autor: pangting
 * @Date: 2023-05-24 16:37:10
 * @LastEditors: pangting
 * @LastEditTime: 2023-05-24 16:37:15
 */
/*
 * @Author: your name
 * @Date: 2022-02-24 14:04:49
 * @LastEditTime: 2022-02-24 14:07:39
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \CoreWeb\packages\Api\fsserver-api\src\OSSFileApi.ts
 */
import { FsServerBaseApi } from "./FsServerBaseApi";
/**
 * File Api
 */
export class OSSFileApi extends FsServerBaseApi {
    public get ControllerName(): any {
        return 'OSSFile'
    }

    /**
     * 获取凭证
     * @returns 
     */
    public GetAliSTS() {
        return this.send({}, 'GetAlOSS', this.Methods.GET);
    }

}
